import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

export async function checkForUpdates() {
  try {
    const info = await App.getInfo();

    const currentVersion = parseInt(info.version);

    const response = await fetch(
      'https://liberte.joss-serveur.duckdns.org/version.json'
    );

    const data = await response.json();

    if (data.versionCode > currentVersion) {
      const confirmUpdate = window.confirm(
        `Nouvelle version disponible (${data.versionName})\n\n${data.changelog.join('\n')}`
      );

      if (confirmUpdate) {
        await Browser.open({
          url: data.apkUrl
        });
      }
    }
  } catch (err) {
    console.error('Erreur update:', err);
  }
}